
/* injects from baggage-loader */

import React from 'react';
import { connect } from 'react-redux';
import Config from "../../../../dev/config/main";
import PropTypes from 'prop-types';

const MoneyAmount = ({ amount, user, currency, currencyConfig, onClick }) => {
    if (amount === undefined) return null;

    const terminalCurrency = JSON.parse(sessionStorage.getItem("authData")).currency;

    const currencyType = currency || user?.profile?.currency_id;
    const selectedCurrencyConfig = (currencyType && currencyConfig[currencyType]) || { rounding: Config.main.currencyRounding };
  
    return <>
        {Config.enableCurrencyView && <span>{Config.main.currency[terminalCurrency]}</span>}
        <i onClick={onClick}>{parseFloat(amount).toFixed(Math.abs(selectedCurrencyConfig.rounding))}</i>
    </>;
};

MoneyAmount.propTypes = {
    amount: PropTypes.number,
    currency: PropTypes.string,
    onClick: PropTypes.funcs
};

const mapStateToProps = state => ({
    currencyConfig: state.swarmConfigData.currency,
    user: state.user
});

export default connect(mapStateToProps)(MoneyAmount);